export default __webpack_public_path__ + "static/media/fauna-runas-prd.160abb0b.png";